export default __webpack_public_path__ + "static/media/0128.cbb949e9.png";